<!--Footer Starts-->
<footer class="footer">
  <p class="copyright clearfix text-muted m-0">
    Copyright &copy; {{currentDate | date: 'yyyy'}} Plataforma Census
    <span class="d-none d-sm-inline-block">, Todos direitos reservados.</span>
  </p>
</footer>
<!--Footer Ends-->
